import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import videoService from '../../services/video.service';

export const addVideo = createAsyncThunk('videoSlice/addVideo', async (params, thunkAPI) => {
  try {
    const data = await videoService.addVidoeAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getVideo = createAsyncThunk('videoSlice/getVideo', async (params, thunkAPI) => {
  try {
    const data = await videoService.getVidoeAPI();
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getVideoDetail = createAsyncThunk('videoSlice/getVideoDetail', async (params, thunkAPI) => {
  try {
    const data = await videoService.getVideoDetailAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const deleteVideo = createAsyncThunk('videoSlice/deleteVideo', async (params, thunkAPI) => {
  try {
    const data = await videoService.deleteVideoAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const updateVideo = createAsyncThunk('videoSlice/updateVideo', async (params, thunkAPI) => {
  try {
    const data = await videoService.updateVideoAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  videoList: []
};

const videoSlice = createSlice({
  name: 'videoSlice',
  initialState,
  extraReducers: {
    [getVideo.fulfilled]: (state, action) => {
      state.videoList = action.payload.data.videoList;
    }
  }
});

const { reducer } = videoSlice;
export default reducer;
